import { SponsorshipReward } from './SponsorshipReward/SponsorshipReward'

interface Props {
  referrerReward: number
  refereeReward: number
}

export const SponsorshipRewards = ({
  referrerReward,
  refereeReward,
}: Props) => {
  return (
    <div className="mb-6 flex divide-x divide-info-200">
      <SponsorshipReward
        recipient="referrer"
        rewardAmount={referrerReward}
        className="pr-8"
      />
      <SponsorshipReward
        recipient="referee"
        rewardAmount={refereeReward}
        className="pl-8"
      />
    </div>
  )
}
